<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :loader="'dots'"
      :height="150"
      :width="150"
      :color="'#F1557A'"
      :is-full-page="fullPage"
    ></loading>
    <d-container fluid class="main-content-container px-4">
      <!-- Page Header -->
      <d-row class="page-header row no-gutters py-4">
        <d-col col sm="8" class="text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Your Givemagic</span>
          <h3 class="page-title">Settings</h3>
        </d-col>
        <div class="col-lg-4 col-sm-4 mb-0">
          <d-button class="btn-blue btn-right" @click="onSave">
            <i class="material-icons">save</i> Save Settings
          </d-button>
        </div>
      </d-row>
    </d-container>
    <div>
      <!--<d-alert class="alert-royal-blue" show>
        <i class="fa fa-info mx-2"></i>
        <strong>How you doin'?</strong> I'm just a friendly, good-looking notification message and I come in all the colors you can see below. Pretty cool, huh?
      </d-alert>-->

      <d-container fluid class="main-content-container px-4">
        <d-row>
          <d-col lg="8" class="mb-4">
            <d-card class="card-style mb-4">
              <d-card-header class="border-bottom">
                <h6 class="m-0">Workspace Settings</h6>
              </d-card-header>

              <d-list-group flush>
                <d-list-group-item class="p-1 mt-2">
                  <d-row>
                    <!-- Forms -->
                    <d-col sm="12" md="12">
                      <d-form>
                        <div class="form-group">
                          <label>Organization Name</label>
                          <d-input v-model="Organization_Name" />
                        </div>
                        <div class="form-group">
                          <label>Workspace Name</label>
                          <p class="explainer">Your ___________.givemagicstories.com url</p>
                          <d-input v-model="Workspace_Name" />
                        </div>
                        <div class="form-group">
                          <label>Your Website</label>
                          <d-input v-model="Workspace_Url" />
                        </div>

                        <d-form-row>
                          <d-col md="6">
                            <div class="form-group">
                              <label>Primary Color</label>
                              <d-input-group>
                                <d-input v-model="Primary_Color" placeholder="#000"></d-input>
                              </d-input-group>
                            </div>
                          </d-col>
                          <d-col md="6">
                            <div class="form-group">
                              <label>Secondary Color</label>
                              <d-input-group>
                                <d-input v-model="Secondary_Color" placeholder="#000"></d-input>
                              </d-input-group>
                            </div>
                          </d-col>
                          <d-col md="6">
                            <strong class="d-block mb-2">Upload Logo</strong>
                            <div class="custom-file mb-3">
                              <input
                                @change="onChangeFile"
                                type="file"
                                class="custom-file-input"
                                id="customFile2"
                              />
                              <label
                                class="custom-file-label"
                                for="customFile2"
                              >Select a square, 1:1 aspect ratio, image...</label>
                            </div>
                          </d-col>
                          <d-col md="12">
                            <div class="form-group">
                              <label>SMS</label>
                              <p class="explainer">
                                If turned on, GiveMagic will SMS supporter's who
                                have sms as their communication preference.
                              </p>
                              <d-checkbox
                                v-if="!sms_alert"
                                @change="checkToggle"
                                toggle
                              >Text messaging off</d-checkbox>
                              <d-checkbox
                                v-if="sms_alert"
                                @change="checkToggle"
                                toggle
                                checked
                              >Text messaging on</d-checkbox>
                            </div>
                          </d-col>
                          <d-col md="6">
                            <div class="form-group">
                              <label>Stripe Client ID</label>
                              <d-input-group>
                                <d-input v-model="Stripe_client_id" placeholder="acct_xxxxxxxxx"></d-input>
                              </d-input-group>
                            </div>
                          </d-col>
                        </d-form-row>
                      </d-form>
                    </d-col>
                  </d-row>
                </d-list-group-item>
              </d-list-group>
            </d-card>

            <d-card class="card-style">
              <!-- Form Example -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Thank You Email Template</h6>
              </d-card-header>

              <d-list-group flush>
                <d-list-group-item class="p-1 mt-2">
                  <d-row>
                    <d-col>
                      <d-form>
                        <div class="form-group">
                          <div class="form-group">
                            <label>Email Subject Title</label>
                            <d-input v-model="email_template_title" />
                          </div>
                          <div class="form-group">
                            <label>Reply-To Email</label>
                            <d-input v-model="reply_to_email" />
                          </div>
                          <!--<d-checkbox toggle class="custom-toggle-sm" checked>Caption Videos</d-checkbox>-->
                        </div>
                        <label class="d-block mb-2">Email Body</label>
                        <p class="explainer">
                          Email editor is in HTML. Feel free to use the
                          following mail merge tags:
                          <span
                            v-pre
                          >{{{amount_donated}}}</span>,
                          <span v-pre>{{{donation_frequency}}}</span>,
                          <span v-pre>{{{call_to_action_title}}}</span>,
                          <span v-pre>{{{first_name}}}</span>,
                          <span v-pre>{{{last_name}}}</span>,
                          <span v-pre>{{{organization_name}}}</span>.
                        </p>
                        <br />
                        <vue-editor
                          v-model="email_template_body"
                          :style="{ fontSize: '1rem' }"
                          class="email-editor"
                          :config="config"
                        ></vue-editor>
                      </d-form>
                    </d-col>
                  </d-row>
                </d-list-group-item>
              </d-list-group>
            </d-card>
            <br />
          </d-col>

          <d-col lg="4" class="mb-4">
            <!-- Sliders & Progress Bars -->
            <d-card class="card-style mb-4">
              <d-card-header class="border-bottom">
                <h6 class="m-0">Donation Settings</h6>
              </d-card-header>
              <d-list-group flush>
                <d-list-group-item class="p-1 mt-2">
                  <d-form>
                    <label class="d-block mb-2">One-Time Donation Amounts</label>
                    <d-input-group prepend="1st Level" class="mb-3">
                      <d-select v-model="one_time_donation_options[0]">
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                        <option>35</option>
                        <option>40</option>
                        <option>45</option>
                        <option>50</option>
                        <option>55</option>
                        <option>65</option>
                        <option>70</option>
                        <option>75</option>
                        <option>100</option>
                        <option>125</option>
                        <option>150</option>
                        <option>200</option>
                        <option>250</option>
                        <option>300</option>
                        <option>400</option>
                        <option>500</option>
                      </d-select>
                    </d-input-group>
                    <d-input-group prepend="2nd Level" class="mb-3">
                      <d-select v-model="one_time_donation_options[1]">
                        <option>5</option>
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                        <option>35</option>
                        <option>40</option>
                        <option>45</option>
                        <option>50</option>
                        <option>55</option>
                        <option>65</option>
                        <option>70</option>
                        <option>75</option>
                        <option>100</option>
                        <option>125</option>
                        <option>150</option>
                        <option>200</option>
                        <option>250</option>
                        <option>300</option>
                        <option>400</option>
                        <option>500</option>
                      </d-select>
                    </d-input-group>
                    <d-input-group prepend="3rd Level" class="mb-3">
                      <d-select v-model="one_time_donation_options[2]">
                        <option>5</option>
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                        <option>35</option>
                        <option>40</option>
                        <option>45</option>
                        <option>50</option>
                        <option>55</option>
                        <option>65</option>
                        <option>70</option>
                        <option>75</option>
                        <option>100</option>
                        <option>125</option>
                        <option>150</option>
                        <option>200</option>
                        <option>250</option>
                        <option>300</option>
                        <option>400</option>
                        <option>500</option>
                      </d-select>
                    </d-input-group>
                    <d-input-group prepend="4th Level" class="mb-3">
                      <d-select v-model="one_time_donation_options[3]">
                        <option>5</option>
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                        <option>35</option>
                        <option>40</option>
                        <option>45</option>
                        <option>50</option>
                        <option>55</option>
                        <option>65</option>
                        <option>70</option>
                        <option>75</option>
                        <option>100</option>
                        <option>125</option>
                        <option>150</option>
                        <option>200</option>
                        <option>250</option>
                        <option>300</option>
                        <option>400</option>
                        <option>500</option>
                      </d-select>
                    </d-input-group>
                    <label class="d-block mb-2">Default One-Time Level</label>
                    <d-input-group prepend="Select" class="mb-3">
                      <d-select v-model="default_one_time_level">
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                      </d-select>
                    </d-input-group>
                    <label class="d-block mb-2">Monthly Donation Amounts</label>
                    <d-input-group prepend="1st Level" class="mb-3">
                      <d-select v-model="monthly_donation_options[0]">
                        <option>5</option>
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                        <option>35</option>
                        <option>40</option>
                        <option>45</option>
                        <option>50</option>
                        <option>55</option>
                        <option>65</option>
                        <option>70</option>
                        <option>75</option>
                        <option>100</option>
                        <option>125</option>
                        <option>150</option>
                        <option>200</option>
                        <option>250</option>
                        <option>300</option>
                        <option>400</option>
                        <option>500</option>
                      </d-select>
                    </d-input-group>
                    <d-input-group prepend="2nd Level" class="mb-3">
                      <d-select v-model="monthly_donation_options[1]">
                        <option>5</option>
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                        <option>35</option>
                        <option>40</option>
                        <option>45</option>
                        <option>50</option>
                        <option>55</option>
                        <option>65</option>
                        <option>70</option>
                        <option>75</option>
                        <option>100</option>
                        <option>125</option>
                        <option>150</option>
                        <option>200</option>
                        <option>250</option>
                        <option>300</option>
                        <option>400</option>
                        <option>500</option>
                      </d-select>
                    </d-input-group>
                    <d-input-group prepend="3rd Level" class="mb-3">
                      <d-select v-model="monthly_donation_options[2]">
                        <option>5</option>
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                        <option>35</option>
                        <option>40</option>
                        <option>45</option>
                        <option>50</option>
                        <option>55</option>
                        <option>65</option>
                        <option>70</option>
                        <option>75</option>
                        <option>100</option>
                        <option>125</option>
                        <option>150</option>
                        <option>200</option>
                        <option>250</option>
                        <option>300</option>
                        <option>400</option>
                        <option>500</option>
                      </d-select>
                    </d-input-group>
                    <d-input-group prepend="4th Level" class="mb-3">
                      <d-select v-model="monthly_donation_options[3]">
                        <option>5</option>
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                        <option>35</option>
                        <option>40</option>
                        <option>45</option>
                        <option>50</option>
                        <option>55</option>
                        <option>65</option>
                        <option>70</option>
                        <option>75</option>
                        <option>100</option>
                        <option>125</option>
                        <option>150</option>
                        <option>200</option>
                        <option>250</option>
                        <option>300</option>
                        <option>400</option>
                        <option>500</option>
                      </d-select>
                    </d-input-group>
                    <label class="d-block mb-2">Default Monthly Level</label>
                    <d-input-group prepend="Select" class="mb-3">
                      <d-select v-model="default_monthly_level">
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                      </d-select>
                    </d-input-group>
                  </d-form>
                </d-list-group-item>
              </d-list-group>
            </d-card>
            <d-card class="card-style">
              <!-- Form Example -->
              <d-card-header class="border-bottom">
                <h6 class="m-0">Add a User</h6>
              </d-card-header>

              <d-list-group flush>
                <d-list-group-item class="p-1 mt-2">
                  <d-row>
                    <d-col>
                      <d-form>
                        <d-form-row>
                          <d-col md="12" class="form-group">
                            <div class="form-group">
                              <label for="feInputAddress">First Name</label>
                              <d-input
                                id="feInputAddress"
                                placeholder="1234 Main St"
                                v-model="form.first_name"
                              />
                              <p
                                v-if="showError && !this.form.first_name"
                                class="form-error"
                              >Please Enter first name</p>
                            </div>
                            <div class="form-group">
                              <label for="feInputAddress">Last Name</label>
                              <d-input
                                id="feInputAddress"
                                placeholder="1234 Main St"
                                v-model="form.last_name"
                              />
                              <p
                                v-if="showError && !this.form.last_name"
                                class="form-error"
                              >Please enter your last name</p>
                            </div>
                            <div class="form-group">
                              <label for="feEmailAddress">Email</label>
                              <d-input
                                id="feEmailAddress"
                                type="email"
                                placeholder="Email"
                                v-model="form.email"
                              />
                              <p
                                v-if="showError && !this.form.email"
                                class="form-error"
                              >Please enter an email address</p>
                            </div>
                            <div class="form-group">
                              <label for="feEmailAddress">Phone Number</label>
                              <d-input
                                id="feEmailAddress"
                                type="phone"
                                placeholder="Phone"
                                v-model="form.phone_number"
                              />
                              <p
                                v-if="showError && !this.form.phone_number"
                                class="form-error"
                              >Please enter a phone number</p>
                            </div>
                          </d-col>
                          <div class="form-group">
                            <d-button-group class="mb-3 ml-1">
                              <d-button
                                @click="onTypeChange"
                                v-bind:class="[
                                  Storyteller ? 'btn-primary' : 'btn-white'
                                ]"
                              >Storyteller</d-button>
                              <d-button
                                @click="onTypeChange"
                                v-bind:class="[
                                  Admin ? 'btn-primary' : 'btn-white'
                                ]"
                              >Admin</d-button>
                            </d-button-group>
                          </div>
                        </d-form-row>
                        <d-form-row>
                          <!--<d-col md="12" class="form-group">
                            <d-checkbox>I agree with your <a href="#">Privacy Policy</a>.</d-checkbox>
                          </d-col>-->
                        </d-form-row>
                        <d-button type="submit" @click="sendInvite">Send Invitation</d-button>
                        <p class="form-error" v-if="serverError">{{ serverError }}</p>
                      </d-form>
                    </d-col>
                  </d-row>
                </d-list-group-item>
              </d-list-group>
            </d-card>
          </d-col>
        </d-row>
      </d-container>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueColorPickerBoard from "vue-color-picker-board";
import settingTypes from "../vuex/setting/setting.types";
import { VueEditor } from "vue2-editor";
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);

export default {
  data() {
    return {
      Organization_Name: "",
      Workspace_Name: "",
      Workspace_Url: "add your url",
      file: null,
      Primary_Color: "",
      Stripe_client_id: "",
      Secondary_Color: "",
      sms_alert: false,
      email: "",
      default_monthly_level: "",
      default_one_time_level: "",
      one_time_donation_options: [],
      monthly_donation_options: [],
      email_template_body: "",
      email_template_title: "",
      reply_to_email: "",
      config: {
        placeholder:
          "Thank you for your generous gift to {{{organization_name}}} of {{{amount_donated}}}. Through your gift we are able to accomplish our mission and continue working towards our goals. <br> You truly are making the difference for us {{{first_name}}] and we are extremely grateful! If you have specific questions about your gift is being used or {{{organization_name}}} as a whole, please don't hesitate to reach out. Sincerely, {{{organization_name}}}"
      },
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        isAdmin: false
      },
      Storyteller: true,
      Admin: false,
      serverError: "",
      fullPage: true,
      isLoading: false,
      showError: false
    };
  },
  components: {
    Loading,
    VueEditor
  },
  computed: {
    ...mapState({
      type: state => state.setting.type,
      data: state => state.setting.data,
      error: state => state.setting.error
    })
  },
  methods: {
    emailTemplateInput(e) {
      this.email_template_body = e.target.innerText;
    },
    onChangeFile(e) {
      let file = e.target.files[0];
      this.file = file;
      const logoData = {
        logo: this.file
      };
      this.$store.dispatch("editLogo", logoData);
    },
    onSave() {
      const data = {
        organization_name: this.Organization_Name,
        workspace_name: this.Workspace_Name,
        primary_color: this.Primary_Color,
        stripe_client_id: this.Stripe_client_id,
        secondary_color: this.Secondary_Color,
        sms_alert: this.sms_alert,
        reply_to_email: this.reply_to_email,
        default_one_time_level: this.default_monthly_level,
        default_monthly_level: this.default_one_time_level,
        monthly_donation_options: this.monthly_donation_options,
        one_time_donation_options: this.one_time_donation_options,
        organization_url: this.Workspace_Url,
        thank_you_email_body: this.email_template_body,
        thank_you_email_heading: this.email_template_title
      };
      this.$store.dispatch("editSettings", data);
    },
    onTypeChange(e) {
      e.preventDefault();
      this.Storyteller = !this.Storyteller;
      this.Admin = !this.Admin;
      if (this.Storyteller && !this.Admin) {
        this.form.isAdmin = false;
      } else {
        this.form.isAdmin = true;
      }
    },
    sendInvite(e) {
      e.preventDefault();
      this.showError = false;
      this.serverError = false;
      if (!this.validate()) return;
      const data = this.form;
      this.$store.dispatch("AddEmployees", data);
    },
    validate() {
      const form = this.form;
      if (
        !form.email ||
        !form.phone_number ||
        !form.first_name ||
        !form.last_name
      ) {
        this.showError = true;
        return false;
      }
      return true;
    },
    checkToggle(e) {
      this.sms_alert = e;
    }
  },
  watch: {
    type(type) {
      if (type === settingTypes.FETCH_SETTING_REQUEST) {
        this.isLoading = true;

        //window.location.reload();
      } else if (type === settingTypes.FETCH_SETTING_SUCCESS) {
        if (this.data.setting) {
          const Settings = this.data.setting;
          this.Organization_Name = Settings.organization_name;
          this.Workspace_Name = Settings.workspace_name;
          this.Primary_Color = Settings.primary_color;
          this.Stripe_client_id = Settings.stripe_client_id;
          this.Secondary_Color = Settings.secondary_color;
          this.sms_alert = Settings.sms_alert;
          this.default_monthly_level = Settings.default_monthly_level;
          this.default_one_time_level = Settings.default_one_time_level;
          this.one_time_donation_options = Settings.one_time_donation_options;
          this.monthly_donation_options = Settings.monthly_donation_options;
          this.reply_to_email = Settings.reply_to_email;
          this.Workspace_Url = Settings.organization_url;
          this.email_template_body = Settings.thank_you_email_body;
          this.email_template_title = Settings.thank_you_email_heading;
          this.isLoading = false;
        }
      } else if (type === settingTypes.FETCH_SETTING_FAILED) {
        this.isLoading = false;
        this.$toasted.clear();
        this.$toasted.error(this.error, {
          icon: "error_outline",
          duration: 3000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (type === settingTypes.UPDATE_SETTING_REQUEST) {
        this.isLoading = true;
        // this.$toasted.info("Saving Info...", {
        //   icon: "hourglass_empty",
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
      } else if (type === settingTypes.UPDATE_SETTING_SUCCESS) {
        this.isLoading = false;
        this.$toasted.success("Saved", {
          icon: "hourglass_empty",
          fullWidth: false,
          keepOnHover: true,
          duration: 3000,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (type === settingTypes.UPDATE_SETTING_FAILED) {
        this.isLoading = false;
        this.$toasted.error(this.error, {
          icon: "error_outline",
          duration: 3000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (type === settingTypes.ADD_EMPLOYEE_REQUEST) {
        this.isLoading = true;
        // this.$toasted.info("Adding User", {
        //   icon: "hourglass_empty",
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
        // this.$toasted.clear();
      } else if (type === settingTypes.ADD_EMPLOYEE_SUCCESS) {
        this.isLoading = false;
        this.$toasted.success("successfully added ", {
          icon: "hourglass_empty",
          fullWidth: false,
          keepOnHover: true,
          duration: 3000,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
        this.form = {
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          type: "storyteller"
        };
      } else if (type === settingTypes.ADD_EMPLOYEE_FAILED) {
        this.isLoading = false;
        this.$toasted.error(this.error, {
          icon: "error_outline",
          duration: 3000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    }
  },

  mounted() { },
  created() {
    this.$store.dispatch("fetchSetting");
  }
};
</script>

<style>
.add-new-post__editor {
  height: 200px !important;
}

.explainer {
  margin-top: 0px;
  font-size: 80%;
  color: grey;
  margin-bottom: 5px;
}
.see-example {
  display: inline-block;
  text-decoration: underline !important;
  text-decoration-style: dashed !important;
  color: #f2557a !important;
}

pre {
  margin-bottom: 0.75rem;
  font-size: 0.75rem;
  color: #414770;
  line-height: 1.375rem;
  background: #fafcff;
  border-radius: 5px;
}
.form-error {
  padding: 0px 5px;
  font-size: 13px;
  text-align: left;
  justify-content: flex-start;
  color: #e02020;
  margin: 0;
}
.color-large {
  width: 100px;
  border: none;
  height: 70px;
  outline: none;
  -webkit-appearance: none;
  padding: 0px;
}

.input-group-text {
  max-height: 37px;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  color: #232349;
  border: 1px solid #e1e5eb;
}
.form-divider {
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  border-bottom: 1px solid #e1e5eb;
}

.screenshot {
  width: 275px;
  margin: 0 auto;
}
.form-control {
  font-size: 1rem;
}

.email-editor {
  height: 300px;
  margin-bottom: 50px;
}
.ql-toolbar {
  display: flex;
  align-items: center;
}

.ql-snow .ql-picker {
  margin-top: -5px;
}
</style>
